// extracted by mini-css-extract-plugin
export default {"content-container":"ChangeContent_content-container__W4kUJ"};